export const CONSONANT_VOWEL_PAIRS_SILENT_NG = [

    // ㄴ
    {
        id: 1,
        korean: "아",
        english: "a",

    },
    {
        id: 2,
        korean: "에",
        english: "e",

    },
    {
        id: 3,
        korean: "이",
        english: "i",

    },
    {
        id: 4,
        korean: "오",
        english: "o",

    },
    {
        id: 5,
        korean: "응",
        english: "eung",

    },
    {
        id: 6,
        korean: "엉",
        english: "eong",

    },
    {
        id: 7,
        korean: "야",
        english: "ya",

    },
    {
        id: 8,
        korean: "애",
        english: "ae",

    },
    {
        id: 9,
        korean: "예",
        english: "ye",

    },
    {
        id: 10,
        korean: "요",
        english: "yo",

    },
    {
        id: 11,
        korean: "여",
        english: "yeo",

    },
    {
        id: 12,
        korean: "유",
        english: "yu",

        

    },

    {
        id: 13,
        korean: "안",
        english: "an", 

    },
    {
        id: 14,
        korean: "악",
        english: "ak",

        

    },
    {
        id: 15,
        korean: "임",
        english: "im",
        

    },
    {
        id: 16,
        korean: "앗",
        english: "at",
        

    },
    {
        id: 17,
        korean: "앟",
        english: "ah",
        

    },
    {
        id: 18,
        korean: "업",
        english: "eob",
        

    },
          {
        id: 19,
        korean: "을",
        english: "eul",
        

    },
    {
        id: 20,
        korean: "앞",
        english: "ap",
        

    },
    {
        id: 21,
        korean: "앢",
        english: "aekk",
        

    },
    {
        id: 22,
        korean: "앤",
        english: "aen",
        

    },
    {
        id: 23,
        korean: "의",
        english: "ui",
        

    },
    {
        id: 24,
        korean: "움",
        english: "um",
        

    },

    {
        id: 25,
        korean: "얒",
        english: "yat",
        

    },
    {
        id: 26,
        korean: "앗",
        english: "at",
        

    },
    {
        id: 27,
        korean: "앙",
        english: "ang",
        
    },
    {
        id: 28,
        korean: "알",
        english: "al",
        
    },
    {
        id: 29,
        korean: "열",
        english: "yeol",
        
    },
    {
        id: 30,
        korean: "알",
        english: "al",
        
    },
    {
        id: 31,
        korean: "엏",
        english: "eoh",
        
    },
    {
        id: 32,
        korean: "을",
        english: "eul",
        
    },
        {
        id: 33,
        korean: "워",
        english: "wo",
        
    },
    {
        id: 34,
        korean: "웊",
        english: "yup",
        
    },
    {
        id: 35,
        korean: "엪",
        english: "ep",
        
    },
    {
        id: 36,
        korean: "어",
        english: "eo",
        
    }

    
];

